<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" />
			<span>在线考试</span><i class="el-icon-arrow-right"></i>&nbsp;<span>考试详情</span>
		</div>
		<div class="content" v-loading="loading" :element-loading-text="loadingtext">
			<div class="listTitle">
				<i class="el-icon-s-management"></i> {{taskinfo.name}}（共{{topicinfo.topicAmount}}道题，共{{topicinfo.totalScore}}分，答对{{rightNum}}道）
				<span class="listTime r" style="margin: 0 0 0 15px;" v-show="recordinfo.representationStatus !='1'"><el-button type='primary' @click='representate = true'>申诉</el-button></span>
				<span class="listTime r">得分：{{userScore}}</span>
			</div>
			<div class="course-info-main clearfix ">
				<div v-for="(item,index) in qusetionlist">
					<div :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'">
						<div class="questionTitle">
							{{index+1}}、
							<span v-if="item.topicType == 4">
									{{item.question | spliceQuestion}}
								</span>
							<span v-if="item.topicType != 4">
									{{item.question}}
								</span> <span class="maincolor">（<span v-if="item.topicType == 1">单选题</span>
							<span v-if="item.topicType == 2">多选题</span>
							<span v-if="item.topicType == 3">判断题</span>
							<span v-if="item.topicType == 4">填空题</span>
							<span v-if="item.topicType == 5">简答题</span>，分值：{{item.score}}，{{item.userScore!=null?'得分'+item.userScore:'未批改'}}）</span>
							<div v-if="item.isFile == '1'" class="filebox" style="margin: 20px 0 0 0;">
								<div class="fileboxname">图片/视频：</div>
								<div>
									<span :key='file.id' v-for="(file,fileindex) in item.files">
										<video style="width: 150px; height: 150px" :src="baseurl + file.url" v-if="file.url.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image fit="fill" style="width: 150px; height: 150px" :src="baseurl + file.url" :preview-src-list="[baseurl + file.url]" v-else>
										</el-image>
										</span>
								</div>
							</div>
						</div>
						<div v-if="item.topicType == 1">
							<div class="questionAnswers" v-for="(it,i) in item.answerlist">
								<div :class="'questionLabel questionLabel'+ item.chooseRight">
									<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
										<div class="inCircle"></div>
									</div>
								</div>
								<span>{{it.label}}、<span v-if="it.type == '1'">{{it.value}}</span>
								<span v-if="it.type == '2'">
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
								</span>
							</div>
						</div>
						<div v-if="item.topicType == 2">
							<div class="questionAnswers" v-for="(it,i) in item.answerlist">
								<div :class="'questionLabel questionLabel'+ item.chooseRight">
									<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
										<div class="inCircle"></div>
									</div>
								</div>
								<span>{{it.label}}、	<span v-if="it.type == '1'">{{it.value}}</span>
								<span v-if="it.type == '2'">
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
								</span>
							</div>
						</div>
						<div v-if="item.topicType == 3">
							<div class="questionAnswers" v-for="(it,i) in item.answerlist">
								<div :class="'questionLabel questionLabel'+ item.chooseRight">
									<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
										<div class="inCircle"></div>
									</div>
								</div>
								<span>{{it.label}}、	<span v-if="it.type == '1'">{{it.value}}</span>
								<span v-if="it.type == '2'">
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
								</span>
							</div>
						</div>
						<div class="questionFooter" v-if="item.topicType == 1 || item.topicType == 2 || item.topicType == 3">
							我的答案：{{item.userAnswer}}&nbsp;&nbsp;
							<i class="iconfont iconcuo" v-if="item.chooseRight == '0'" style="color: #F56C6C;"></i>
							<i class="iconfont icondui" v-if="item.chooseRight == '1'" style="color: #00B43C;"></i>
						</div>
						<div class="questionFooter" v-if="item.topicType == 4">
							我的答案：{{item.userAnswer}}
						</div>
						<div class="questionFooter" v-if="item.topicType == 5">
							<div v-html="getAnswer(item)"></div>
						</div>
						<div class="fileArrbox" v-if="item.userAnswerFilearr && item.userAnswerFilearr.length>0">
							<div class="uploadFile" @click.stop="formPreview(file)" v-for="(file,index) in item.userAnswerFilearr">
								<img src="@/images/word.png" />
								<div class="p1">
									{{file.name}}
								</div>
								<div class="p2">
									{{file.size | filesize}}
								</div>
							</div>
							<div style="clear: both;"></div>
						</div>
						<div class="questionFooter" v-if="item.topicType == 4">
							参考答案：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
						</div>
						<div class="questionFooter" v-if="item.topicType != 4">
							参考答案：{{item.answer}}
						</div>
						<div class="questionFooter" v-if="item.topicType == 5">
							关键词：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
						</div>
						<div class="questionFooter">
							解析：{{item.analysis }}
						</div>
						<div class="questionFooter" v-show='item.comment'>
							教师评语：{{item.comment }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="viewName==''?'预览':viewName" :visible.sync="viewShow" append-to-body>
			<div class="viewIframe" v-if="viewShow" v-loading="viewShowLoading">
				<iframe :src="playUrl" v-if="!viewAideoShow"  @load="viewShowLoading = false"></iframe>
				<audio :src="playUrl" v-if="viewAideoShow" controls="controls"></audio>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="viewShow = false">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提交申诉" :visible.sync="representate">
			<el-input type="textarea" resize="none" :rows="6" placeholder="请输入内容" v-model="representation">
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="representateAdd" :disabled='dataloading'>确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { downloadFile } from "@/utils/oss.js"
	import { getRecordInfo, getExamineById, addRepresentation } from '@/api/examine.js'
	export default {
		name: 'taskdetails',
		data() {
			return {
				testId: '',
				examId: '',
				userScore: 0,
				rightNum: 0,
				loading: true,
				loadingtext: '题目加载中...',
				questionindex: 0,
				testinfo: [],
				questionove: [],
				qusetionlist: [],
				taskinfo: {},
				topicinfo: {},
				recordinfo: {},
				//文件
				playUrl: '',
				viewName: '',
				viewShowLoading: true,
				viewShow: false,
				viewAideoShow: false,
				viewopen: window.config.VUE_PDF_FILE,
				//申诉
				dataloading: false,
				representation: '',
				representate: false,
			}
		},
		created() {
			var id = this.$route.query.id;
			if(id) {
				this.id = id;
				this.getTaskinfo();
				this.getTaskitem();
			}
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			representateAdd() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				if(this.representation != '') {
					var data = {
						examineId: this.taskinfo.id,
						examineName: this.taskinfo.name,
						paperId: this.topicinfo.id,
						recordId: this.recordinfo.id,
						representation: this.representation,
					}
					addRepresentation(data).then(res => {
						if(res.code == "OK") {
							this.$message.success('申诉成功,可在个人中心查看')
							this.recordinfo.representationStatus = '1';
							this.representation = '';
							this.representate = false;
						} else {
							this.$message.error('申诉失败，请稍后重试')
						}
					})
				} else {
					this.$message.error('请输入内容')
				}

			},
			getAnswer(item) {
				if(item.userAnswer){
					var answerlist = item.answerlist;
					var answerStr = '我的答案：';
					var userAnswer = item.userAnswer;
					answerlist.map(answer => {
						userAnswer = userAnswer.split(answer.value).join('<span style="color: #e64242;">' + answer.value + '</span>');
					})
					return answerStr + userAnswer;
				}else{
					return '';
				}
			},
			formPreview(file) {
				var url = file.url;
				var fileUrl = url;
				var fileName = file.name;
				var filetype = file.url.substring(file.url.lastIndexOf('.') + 1);
				this.viewAideoShow = false;
				if(filetype == 'doc' || filetype == 'docx') {
					var playUrl = this.baseurl + url;
					playUrl = this.viewopen + encodeURIComponent(window.btoa(playUrl));
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					this.viewShowLoading = true;
				} else {
					var playUrl = this.baseurl + url;
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					if(filetype == 'mp3' || filetype == 'wav') {
						this.viewAideoShow = true;
					}
				}
			},
			getTaskitem() {
				var data = {
					id: this.id
				}
				getExamineById(data).then(res => {
					if(res.code == 0 && res.data) {
						this.taskinfo = res.data;
						res.data.paperList.map(item => {
							if(item.isUsing == '1') {
								this.topicinfo = item;
							}
						})
					}
				})
			},
			getTaskinfo() {
				var data = {
					examId: this.id
				}
				getRecordInfo(data).then(res => {
					if(res.code == 0) {
						var data = res.data;
						this.recordinfo = data;
						this.userScore = data.score;
						this.rightNum = data.rightNum;
						var userAnswers = data.examineRecordDetail;
						var qusetionlist = [];
						userAnswers.map(item => {
							var qusetionitem = Object.assign({}, item, item.examineTopic)
							qusetionitem.recoreId = item.id;
							qusetionitem.userScore = item.score;
							qusetionlist.push(qusetionitem)
						})
						this.qusetionlist = qusetionlist;
						this.formInit()
					}
				})
			},
			formInit() {
				var qusetionlist = this.qusetionlist;
				qusetionlist.map(item => {
					item.over = false;
					if(item.topicType != 4 && item.topicType != 5) {
						if(!item.userAnswer) {
							item.choose = [];
						} else {
							item.choose = item.userAnswer.split('')
						}

						if(item.userAnswer && item.userAnswer == item.answer) {
							item.chooseRight = 1
						} else {
							item.chooseRight = 0
						}
					}
					if(item.topicType == 5 && item.userAnswerFile && item.userAnswerFile != '') {
						item.userAnswerFilearr = JSON.parse(item.userAnswerFile);
						item.userAnswerFile = item.userAnswerFile;
					}
					if(item.isFile == 1 && item.fileName != null) {
						var files = JSON.parse(item.fileName);
						item.files = files;
						var openfiles = [];
						files.map(item => {
							var openurl = this.baseurl + item.url;
							openfiles.push(openurl)
						})
						item.openfiles = openfiles;
					}
					var answerlist = [];
					if(item.optionA != '' && item.optionA != null) {
						if(item.optionA.indexOf('@') == -1) {
							answerlist[0] = {
								type: '1',
								label: 'A',
								value: item.optionA,
							}
						} else {
							answerlist[0] = {
								type: '2',
								label: 'A',
								value: item.optionA.slice(1),
							}
						}
					}
					if(item.optionB != '' && item.optionB != null) {
						if(item.optionB.indexOf('@') == -1) {
							answerlist[1] = {
								type: '1',
								label: 'B',
								value: item.optionB,
							}
						} else {
							answerlist[1] = {
								type: '2',
								label: 'B',
								value: item.optionB.slice(1),
							}
						}
					}
					if(item.optionC != '' && item.optionC != null) {
						if(item.optionC.indexOf('@') == -1) {
							answerlist[2] = {
								type: '1',
								label: 'C',
								value: item.optionC,
							}
						} else {
							answerlist[2] = {
								type: '2',
								label: 'C',
								value: item.optionC.slice(1),
							}
						}
					}
					if(item.optionD != '' && item.optionD != null) {
						if(item.optionD.indexOf('@') == -1) {
							answerlist[3] = {
								type: '1',
								label: 'D',
								value: item.optionD,
							}
						} else {
							answerlist[3] = {
								type: '2',
								label: 'D',
								value: item.optionD.slice(1),
							}
						}
					}
					if(item.optionE != '' && item.optionE != null) {
						if(item.optionE.indexOf('@') == -1) {
							answerlist[4] = {
								type: '1',
								label: 'E',
								value: item.optionE,
							}
						} else {
							answerlist[4] = {
								type: '2',
								label: 'E',
								value: item.optionE.slice(1),
							}
						}
					}
					if(item.optionF != '' && item.optionF != null) {
						if(item.optionF.indexOf('@') == -1) {
							answerlist[5] = {
								type: '1',
								label: 'F',
								value: item.optionF,
							}
						} else {
							answerlist[5] = {
								type: '2',
								label: 'F',
								value: item.optionF.slice(1),
							}
						}
					}
					item.answerlist = answerlist;
				})
				this.qusetionlist = qusetionlist;
				this.loading = false;
			},
			questionWhere(index) {
				var questionindex = this.questionindex;
				var questionove = this.questionove;
				if(index == questionindex) {
					return 'questionAnswer doing'
				} else if(questionove.indexOf(index) != -1) {
					return 'questionAnswer over'
				} else {
					return 'questionAnswer'
				}
			},
			jumpQuestion(questionindex) {
				if(this.questionindex != questionindex) {
					this.questionindex = questionindex
				}
			},
			prveQuestion() {
				this.questionindex--;
			},
			nextQuestion() {
				this.questionindex++;
			},
			toName(name) {
				if(this.$route.name != name) {
					this.$router.push({
						name
					})
				}
			},
		},
	}
</script>